/**
 * An Accordion Menu Panel header font size can be small, medium, large, and extra-large
 * @public
 */
export const AccordionMenuPanelSizes = {
    small: "small",
    medium: "medium",
    large: "large",
    extraLarge: "extra-large"
};
/**
 * An Accordion Menu Panel expand/collapse icon can appear at the start or end of the accordion
 * @public
 */
export const AccordionMenuPanelMarkerPositions = {
    start: "start",
    end: "end"
};
//# sourceMappingURL=accordion-menu-panel.options.js.map